import type { TranslationResource } from './en';

export const kr: TranslationResource = {
  title: 'AutoCut - 설치 프로그램',
  downloading: 'AutoCut 다운로드 중',
  downloadedTitle: 'AutoCut 다운로드가 완료되었습니다 !',
  closingCountdown: '{{count}}초 후에 닫힙니다',
  alreadyInstalledTitle: 'AutoCut이 이미 설치되어 있습니다',
  alreadyInstalledHelp:
    'AutoCut은 이제 데스크톱 앱으로 실행됩니다. Creative Cloud 앱에서 이 확장 프로그램을 제거할 수 있습니다.',
};
